module.exports = __webpack_public_path__ + "assets/img/titans-hero.d5f0735c.jpg";